var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBauStranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0954503 10.4344C-0.138575 9.94742 0.0725314 9.37124 0.566969 9.1475L20.5856 0.0888394C21.08 -0.1349 21.6705 0.0785326 21.9045 0.565554C22.1386 1.05257 21.9275 1.62876 21.433 1.8525L1.41445 10.9112C0.920011 11.1349 0.329475 10.9215 0.0954503 10.4344Z",
    fill: "#E63ED7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3904 7.63904L20.2467 9.42182C20.7816 9.56091 21.3314 9.25287 21.4747 8.73382C21.618 8.21476 21.3006 7.68123 20.7657 7.54215L16.2178 6.3596L13.3904 7.63904Z",
    fill: "#204BE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17762 4.00894L1.39594 2.50558C0.861062 2.3665 0.31127 2.67453 0.167949 3.19359C0.0246281 3.71264 0.342051 4.24617 0.876932 4.38525L4.35021 5.28838L7.17762 4.00894Z",
    fill: "#204BE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBauStranding);
export default __webpack_public_path__ + "static/media/bau-stranding.3fa7978d7ee057c98c2a7b038f5d5292.svg";
export { ForwardRef as ReactComponent };